import { render, staticRenderFns } from "./StickyMenu.vue?vue&type=template&id=72424578&scoped=true&"
import script from "./StickyMenu.vue?vue&type=script&lang=ts&"
export * from "./StickyMenu.vue?vue&type=script&lang=ts&"
import style0 from "./StickyMenu.vue?vue&type=style&index=0&id=72424578&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72424578",
  null
  
)

export default component.exports